<div class="ledger-filters">
  <mat-form-field>
    <mat-label>START</mat-label>
    <input matInput type="date" [(ngModel)]="startDate">
  </mat-form-field>
  <mat-form-field>
    <mat-label>END</mat-label>
    <input matInput type="date" [(ngModel)]="endDate">
  </mat-form-field>
  <button mat-raised-button type="button" (click)="load()">LOAD LEDGER</button>
</div>

<div *ngIf="loading">
  <h3 style="text-align:center;">LOADING REPORT</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<table mat-table [dataSource]="rows" class="mat-elevation-z2 ledger-table" *ngIf="!loading">
  <ng-container matColumnDef="invoice">
    <th mat-header-cell *matHeaderCellDef>INVOICE</th>
    <td mat-cell *matCellDef="let row">{{ row.invoice }}</td>
  </ng-container>
  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>TYPE</th>
    <td mat-cell *matCellDef="let row">{{ row.type }}</td>
  </ng-container>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>NAME</th>
    <td mat-cell *matCellDef="let row">{{ row.name }}</td>
  </ng-container>
  <ng-container matColumnDef="tax">
    <th mat-header-cell *matHeaderCellDef>TAX</th>
    <td mat-cell *matCellDef="let row">{{ money(row.tax) }}</td>
  </ng-container>
  <ng-container matColumnDef="new">
    <th mat-header-cell *matHeaderCellDef>NEW</th>
    <td mat-cell *matCellDef="let row">{{ money(row.new) }}</td>
  </ng-container>
  <ng-container matColumnDef="discount">
    <th mat-header-cell *matHeaderCellDef>DISCOUNT</th>
    <td mat-cell *matCellDef="let row">{{ money(row.discount) }}</td>
  </ng-container>
  <ng-container matColumnDef="paid">
    <th mat-header-cell *matHeaderCellDef>PAID</th>
    <td mat-cell *matCellDef="let row">{{ money(row.paid) }}</td>
  </ng-container>
  <ng-container matColumnDef="method">
    <th mat-header-cell *matHeaderCellDef>METHOD</th>
    <td mat-cell *matCellDef="let row">{{ row.method }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
